export default "/images/background2.jpg?8a313babd278234d4150bee64f0c7290";